export const NODE_ENV_STG = 'staging';
export const NODE_ENV_PROD = 'production';
